import styled, { keyframes } from "styled-components";

export const Container = styled.div`
    display: flex !important;
    justify-content: center;
    align-items: center;
    overflow: visible;
    flex-direction: column;
`

export const ItemCard = styled.div`
    background-color: ${props => props.capturado == "true" ? props.color : "rgb(180, 186, 196)"};
    border-radius: 20px;
    width: 90vw;
    height: 120px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    box-shadow: 0px -1px 18px -6px rgba(0,0,0,0.49);
    margin-top: 10px;
`
export const PokeItem = styled.li`
    list-style-type: none;
`

const breatheAnimation = keyframes`
  0%, 100% {
    transform: translateY(1px) scale(1) rotateY(15deg);
  }
  50% {
    transform: translateY(-1px) scale(1.01) rotateY(-15deg);
  }
`;
const getRandomDelay = () => `${Math.random() * 2}s`;

export const PokeImg = styled.img`
    width: 70px;
    height: auto;
    margin: 0 -17px;
    animation: ${breatheAnimation} 1.5s ease-in-out infinite;
    animation-delay: ${getRandomDelay};
`
export const BallImg = styled.img`
    position: absolute;
    right: 0;
    width: 25%;
    filter: invert(100%) opacity(20%);
    transform: scale(300%) translateX(-5%);
`

export const ItemData = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    margin-left: 5%;
    margin-bottom: 5%;
`
export const PokeTipo = styled.img`
    transform: scale(.8) translate(-10%, 10%);
    position: absolute;
    left: 0;
    bottom: 0;
`

export const ItemDataRow = styled.div`
    display: flex;
    position: absolute;
    left: 0;
    bottom: 0;
    margin-left: 4%;
    margin-bottom: 3%;
`

export const PotenciaDiv = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0;
    width: 25%;
    height: 80px;
    margin-right: 3%;
    justify-content: center;
    align-items: center;
    padding-bottom: 5%;
    padding-right: 1%;
`

export const PokeEmptyImage = styled.img`
    width: 60%;
`